import { Navigate } from 'react-router-dom';

// Data Explorer 최상위 (/data) — 현재 첫 서브페이지인 공시 탭으로 즉시 전환.
// 향후 탭 6-B (거시) / 6-C (수급) / 6-D (GovernanceContext 이력) 추가 시
// 이 컴포넌트를 탭 셸(레이아웃)으로 승격한다.
export default function DataExplorerPage(): JSX.Element {
  return <Navigate to="/data/disclosures" replace />;
}
